module.exports = __webpack_public_path__ + "img/Imagen-inicio.e2fd694c.jpg";